import * as React from "react";
import { createRoot } from "react-dom/client";
import TaskPane from "./taskpane";
import "./styles.css";
/* global Office */
function mount() {
    const container = document.getElementById("root");
    if (container) {
        createRoot(container).render(React.createElement(TaskPane, null));
    }
}
// Office.onReady is available when loaded inside Outlook.
// Fall back to DOMContentLoaded so the page works in a plain browser too.
if (typeof Office !== "undefined" && Office.onReady) {
    Office.onReady(() => mount());
}
else {
    document.addEventListener("DOMContentLoaded", mount);
}
